import React from 'react';
import "./services.css";
import { 
  FaEye, 
  FaChartLine, 
  FaBullhorn, 
  FaShieldAlt, 
  FaAward, 
  FaHandsHelping,
  FaRegClock,
  FaUsers,
  FaGlobeAsia,
  FaRocket,
  FaStar,
  FaCheckCircle
} from 'react-icons/fa';
import { 
  MdBusinessCenter, 
  MdLocalOffer, 
  MdHealthAndSafety,
  MdOutlineAnalytics,
  MdOutlinePrecisionManufacturing,
  MdOutlineSupportAgent,
  MdOutlineNetworkCheck,
  MdOutlineTrendingUp
} from 'react-icons/md';
import { BiNetworkChart, BiPurchaseTag, BiStore } from 'react-icons/bi';
import { GiPriceTag, GiProgression } from 'react-icons/gi';

function Services() {
  const services = [
    {
      id: 1,
      icon: <GiPriceTag className="service-icon" />,
      title: "Procurement Cost Optimization",
      description: "Strategic sourcing and bulk purchasing power to reduce your optical supply costs by up to 30%",
      color: "#2563eb",
      metrics: "30% Avg. Savings"
    },
    {
      id: 2,
      icon: <MdOutlinePrecisionManufacturing className="service-icon" />,
      title: "Practice Excellence Program",
      description: "Comprehensive practice transformation with state-of-the-art equipment and clinical workflow optimization",
      color: "#7c3aed",
      metrics: "50+ Upgrades"
    },
    {
      id: 3,
      icon: <MdOutlineTrendingUp className="service-icon" />,
      title: "Business Growth Solutions",
      description: "Data-driven marketing strategies and patient acquisition programs to increase your practice revenue",
      color: "#db2777",
      metrics: "40% Growth"
    }
  ];

  const coreCapabilities = [
    {
      id: 1,
      icon: <BiNetworkChart />,
      title: "Pan-Island Network",
      description: "Access to 200+ partnered optical practices across all 25 districts of Sri Lanka"
    },
    {
      id: 2,
      icon: <FaUsers />,
      title: "Collective Buying Power",
      description: "Leverage network-wide procurement for premium optical products at competitive rates"
    },
    {
      id: 3,
      icon: <MdOutlineAnalytics />,
      title: "Clinical Excellence",
      description: "Evidence-based practices and continuing education programs for optical professionals"
    },
    {
      id: 4,
      icon: <FaRegClock />,
      title: "Operational Efficiency",
      description: "Streamlined practice management systems and patient flow optimization"
    }
  ];

  const stats = [
    { id: 1, number: "200+", label: "Partner Practices", sublabel: "Island-wide Network" },
    { id: 2, number: "50K+", label: "Annual Patients", sublabel: "Served Across Network" },
    { id: 3, number: "15+", label: "Years of Excellence", sublabel: "Since 2011" },
    { id: 4, number: "98%", label: "Client Retention", sublabel: "Industry Leading" }
  ];

  const differentiators = [
    {
      id: 1,
      icon: <FaStar />,
      title: "Quality Assurance",
      items: ["ISO-certified products", "Regular quality audits", "Patient safety protocols"]
    },
    {
      id: 2,
      icon: <FaGlobeAsia />,
      title: "Global Partnerships",
      items: ["International optical brands", "Direct manufacturer ties", "Exclusive distribution rights"]
    },
    {
      id: 3,
      icon: <MdOutlineSupportAgent />,
      title: "Comprehensive Support",
      items: ["24/7 technical assistance", "Practice management consulting", "Staff training programs"]
    }
  ];

  return (
    <div className="services-container">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">

          <h1 className="hero-title">
            <span className="title-highlight">Optica International</span>
          </h1>
          <p className="hero-subtitle">
            Sri Lanka's Premier Eye Care Network, Empowering Eye Clinic & Optical Excellence Since 2007
          </p>
          <div className="hero-badges">
            <span className="badge">The Largest Eye Care Network in Sri Lanka</span>
            <span className="badge">20+ International Brands</span>
          </div>
          <div className="hero-stats-mini">
            {/* <div className="mini-stat">
              <span className="mini-stat-number">200+</span>
              <span className="mini-stat-label">Partner Practices</span>
            </div> */}
            <div className="mini-stat">
              <span className="mini-stat-number">15+</span>
              <span className="mini-stat-label">Years Excellence</span>
            </div>

          </div>
        </div>

      </section>

      {/* Main Services Section */}
      <section className="main-services">
        <div className="section-header">
          <span className="section-tag">Our Expertise</span>
          <h2 className="section-title">Comprehensive Practice Solutions</h2>
          <p className="section-subtitle">Tailored programs designed to elevate every aspect of your optical practice</p>
        </div>
        
        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-card-content">
                <div className="service-icon-wrapper" style={{ background: `linear-gradient(135deg, ${service.color}15, ${service.color}05)` }}>
                  <div className="service-icon-circle" style={{ color: service.color }}>
                    {service.icon}
                  </div>
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-metric">
                  <span className="metric-label">Average Impact</span>
                  <span className="metric-value" style={{ color: service.color }}>{service.metrics}</span>
                </div>
                {/* <button className="service-learn-more">
                  Learn More <span className="arrow">→</span>
                </button> */}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Network Excellence Section */}
      <section className="network-section">
        <div className="network-background"></div>
        <div className="network-content">
          <div className="network-badge">
            <BiNetworkChart className="network-icon" />
            <span>Premium Network Member Benefits</span>
          </div>
          <h2 className="network-title">
            Join Sri Lanka's Most Extensive <span className="highlight">Optical Ecosystem</span>
          </h2>
          
          <div className="capabilities-grid">
            {coreCapabilities.map((cap) => (
              <div key={cap.id} className="capability-item">
                <div className="capability-icon">
                  {cap.icon}
                </div>
                <div className="capability-text">
                  <h4>{cap.title}</h4>
                  <p>{cap.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="stats-showcase">
            {stats.map((stat) => (
              <div key={stat.id} className="stat-card">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
                <div className="stat-sublabel">{stat.sublabel}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Differentiators Section */}
      <section className="differentiators-section">
        <div className="section-header">
          <span className="section-tag">Why Choose Us</span>
          <h2 className="section-title">The Optica Advantage</h2>
          <p className="section-subtitle">Setting the standard for optical excellence in Sri Lanka</p>
        </div>

        <div className="differentiators-grid">
          {differentiators.map((item) => (
            <div key={item.id} className="differentiator-card">
              <div className="differentiator-header">
                <div className="differentiator-icon">
                  {item.icon}
                </div>
                <h3>{item.title}</h3>
              </div>
              <ul className="differentiator-list">
                {item.items.map((listItem, index) => (
                  <li key={index}>
                    <FaCheckCircle className="check-icon" />
                    {listItem}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonial/Trust Section */}
      {/* <section className="trust-section">
        <div className="trust-content">
          <div className="trust-logos">
            <span className="trust-label">Trusted by leading institutions</span>
            <div className="logo-placeholders">
              <div className="logo-item">Lanka Hospitals</div>
              <div className="logo-item">Nawaloka</div>
              <div className="logo-item">Asiri</div>
              <div className="logo-item">Durdans</div>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Transform Your Practice?</h2>
          <p className="cta-description">
            Join the 200+ optical practices that have already elevated their standards with Optica International. 
            Schedule a consultation with our practice development team today.
          </p>
          <div className="cta-buttons">
     <a href="/registration">
  <button className="btn btn-primary">
    Join Now
    <span className="btn-icon">→</span>
  </button>
</a>

          </div>

        </div>
      </section>


    </div>
  );
}

export default Services;